require('/src/com/yext/listingslaunchstorm/js/components/styles/contentskeletoncards.module.scss.module.css');

export const contentSkeletonCards = "_content-skeleton-cards_19pqi_1";
export const contentSkeletonCardDesktop = "_content-skeleton-card-desktop_19pqi_1";
export const contentSkeletonRow = "_content-skeleton-row_19pqi_1";
export const card = "_card_19pqi_1";
